import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { VolumePreview } from './components/VolumePreview/VolumePreview';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Reviews } from './components/Reviews';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { leaderVoices, moreLeaderVoices } from './data/testimonials';

/**
 * Vivencia Ready (DPS47). Reviews y Testimonials se renderizan solo si sus
 * arrays tienen contenido real (data/reviews.ts y data/testimonials.ts).
 */
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-pine selection:bg-ember selection:text-pine" data-id="element-0" data-mp="3recdzjv7cnfo">
      <MetaPixel data-id="element-1" data-mp="7ssnarqpf34" />
      <main data-id="element-2" data-mp="2zld2xbxu5jcl">
        <Hero data-id="element-3" data-mp="2zllijblcf2rh" />
        <SocialProofBar data-id="element-4" data-mp="2zm4xcjfp5b1a" />
        <PainGrid data-id="element-5" data-mp="2zmwit1fkxsdu" />
        <ProductReveal data-id="element-6" data-mp="2zng32ospcsv1" />
        <Tomes data-id="element-7" data-mp="33m5be2yvvk7t" />
        <VolumePreview data-id="element-8" data-mp="33lx0uhq8gqzs" />
        <Bonuses data-id="element-9" data-mp="33n6y54p9hv5d" />
        <ValueStack data-id="element-10" data-mp="33orjq4tlm3r3" />
        <Urgency data-id="element-11" data-mp="38lrpsfqg76i7" />
        <Pricing data-id="element-12" data-mp="38l8hlqqlnwhd" />
        <Reviews data-id="element-13" data-mp="38kqau06b9zv7" />
        <Testimonials voices={leaderVoices} background="white" data-id="element-14" data-mp="38k6wetfvdtlx" />
        <Guarantee data-id="element-15" data-mp="3dl4mds74frxz" />
        <Faq data-id="element-16" data-mp="3dlns8ajhypvn" />
        <Testimonials voices={moreLeaderVoices} title="Every facilitator knows this week" background="panel" data-id="element-17" data-mp="3dm5z013scmht" />
        <CostOfInaction data-id="element-18" data-mp="su45bjsmf6ga" />
        <Close data-id="element-19" data-mp="stkjhrzunxwz" />
      </main>
      <Footer data-id="element-20" data-mp="ssssyvl40qdk" />
      <PurchaseNotifications data-id="element-21" data-mp="swgmvvugvest" />
    </div>;
}